import { render, staticRenderFns } from "./TextWithUnits.vue?vue&type=template&id=6ea66610&scoped=true&"
import script from "./TextWithUnits.vue?vue&type=script&lang=js&"
export * from "./TextWithUnits.vue?vue&type=script&lang=js&"
import style0 from "./TextWithUnits.vue?vue&type=style&index=0&id=6ea66610&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea66610",
  null
  
)

export default component.exports